export function formatValue(
  value: number,
  format: 'number' | 'percent' | 'currency',
  prefix?: string,
  suffix?: string,
): string {
  const hasAffix = prefix !== undefined || suffix !== undefined;
  let formatted: string;

  switch (format) {
    case 'percent': {
      const pct = `${(value * 100).toFixed(1)}`;
      formatted = hasAffix ? pct : `${pct}%`;
      break;
    }
    case 'currency': {
      const num = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      formatted = hasAffix ? num : `$${num}`;
      break;
    }
    case 'number':
    default: {
      formatted = value.toLocaleString('en-US', { notation: 'compact', maximumFractionDigits: 1 });
      break;
    }
  }

  const parts: string[] = [];
  if (prefix) parts.push(prefix);
  parts.push(formatted);
  if (suffix) parts.push(suffix);

  return parts.join('');
}
